<template>
  <div class="lcl-quotation-container">
    <div class="lcl-quotation-wrapper">
      <div class="nav-area">
        <div class="nav-wrapper">
          <div class="logo" @click="toMain">
            <img class="image" src="@/images/common/logo_active.svg" />
          </div>
          <div class="info">货代销售智能化办公平台</div>
        </div>
      </div>
      <div class="content-container">
        <div class="content-wrapper" v-if="dataReady" id="exportLcl">
          <div class="show-content">
            <QuotationDetail
              :quotationManager="quotationManager"
              :detail="detail"
              :quotationNo="quotationManager.quotationSaveInfo.quotationNo"
              source="quotationEdit"
              :saleData="saleData"
            ></QuotationDetail>
            <div class="btn-row" v-if="!exportLoading">
              <!-- <div class="save-btn" @click="showSave = true">
                <el-button class="btn-comp" :loading="saveLoading">
                  {{ $t("message.ratePage.baocunbaojiadan") }}
                </el-button>
              </div> -->
              <div class="export-btn">
                <el-button
                  class="btn-comp"
                  type="primary"
                  @click="exportClick"
                  >{{ $t("message.lcl.daochupdf") }}</el-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SaveDialog
      v-show="false"
      v-if="showSave"
      @close="showSave = false"
      :quotationManager="quotationManager"
      :detail="detail"
      @save-completed="handleSaveCompleted"
    ></SaveDialog>
  </div>
</template>

<script>
import * as lclTools from "@/pages/lclFreightList/lclTools.js";
import { LCL_LIST_EXPORT_PDF_SESSION_KEY } from "@/api/keys/index";
import { QuotationManager } from "@/pages/lclFreightList/components/LclQuotationDialog/QuotationManager.js";
import { PureFunc } from "@/pages/rates/QuotationDialog/tools";
import QuotationDetail from "@/pages/lclFreightList/components/QuotationDetail.vue";

import { DateTime } from "@/utils/DateTime";
import { mapState, mapGetters } from "vuex";
// import { getbase64byurlnewAPI } from "@/api/common";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
export default {
  layout: "pdfLayout",
  components: {
    QuotationDetail,
    SaveDialog: () =>
      import(
        "@/pages/lclFreightList/components/LclQuotationDialog/components/SaveDialog.vue"
      ),
  },
  data() {
    return {
      dataReady: false,
      exportLoading: false,
      // ============================================================ 后台字段 START
      showSave: false,
      quotationManager: new QuotationManager(),
      detail: {},
      saveLoading: false,
      // ============================================================  后台字段 END
    };
  },
  computed: {
    saleData() {
      return {
        // nameCn:
        //   this.$store.state.user.expertName || this.$store.state.user.nickname,
        // mobile: this.$store.state.user.mobile,
        //   email: this.$store.state.kefu.email
      };
    },

    ...mapState({}),
  },
  created() {},
  mounted() {
    // ============================================================ 后台逻辑 START
    let sessionData = JSON.parse(
      sessionStorage.getItem(LCL_LIST_EXPORT_PDF_SESSION_KEY)
    );
    console.log("==========sessionData", sessionData);
    // 存储数据
    this.detail = sessionData.detail;
    this.quotationManager = this.quotationManager.fromSelf(
      sessionData.quotationManager
    );
    if (!this.quotationManager.quotationSaveInfo.quotationNo) {
      this.quotationManager.quotationSaveInfo.quotationNo =
        PureFunc.nowTimeStr("LCL");
    }
    this.$nextTick(() => {
      this.dataReady = true;
    });
    // if (this.detail && this.detail.comLogoUrl) {
    // this.image2base64(); //图片转base64
    // }
  },
  methods: {
    handleSaveCompleted(res) {
      this.saveLoading = false;
      this.showSave = false;
      if (+res.code !== 1) {
        this.$message({
          message: res.message,
          type: "error",
        });
        return;
      }
      this.$message({
        message: this.$t("message.ratePage.baocunchenggong"),
        type: "success",
      });

      console.log("==========res", res);
    },
    toMain() {
      this.$router.push("/");
    },
    exportClick() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.exportLoading = true;
      this.$nextTick(() => {
        this.exportPdf();
      });
    },
    exportPdf() {
      const that = this;
      const element = document.querySelector("#exportLcl");
      // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此translate的时候，要把这个差值去掉
      html2canvas(element, { y: 0, scale: 4 }).then((canvas) => {
        const contentWidth = canvas.width;
        const contentHeight = canvas.height - 0; //减40是为了防止分页时将数据切割开不方便观看
        //一页pdf显示html页面生成的canvas高度;
        const pageHeight = (contentWidth / 592.28) * 841.89;
        //未生成pdf的html页面高度
        let leftHeight = contentHeight;
        //页面偏移
        let position = 0;
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        const imgWidth = 595.28;
        const imgHeight = (592.28 / contentWidth) * contentHeight;

        const pageData = canvas.toDataURL("image/jpeg", 1.0);

        const pdf = new jsPDF("", "pt", "a4");

        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        if (leftHeight < pageHeight) {
          pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            //避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage();
            }
          }
        }
        pdf.save(`${this.quotationManager.quotationSaveInfo.quotationNo}.pdf`);
        that.exportLoading = false;
      });
    },
    // async image2base64() {
    //   try {
    //     let params = {
    //       aliFileName: this.detail.comLogoUrl,
    //       // aliFileName:
    //       //   "https://djupload.oss-cn-beijing.aliyuncs.com/etrans56/topSupplier/d703462f771443bea2f3e4c3102bd50d.png"
    //     };
    //     let res = await getbase64byurlnewAPI(params);
    //     if (res.code == 1) {
    //       let url = res.validateMap.fileName;
    //       // this.detail.comLogoBase64 = url;
    //       this.$set(this.detail, "comLogoBase64", url);
    //       // console.log('base==========',url)
    //     }
    //   } catch (error) {
    //     this.$message({
    //       message: this.$i18n.locale == "cn" ? "网络错误" : "Network error",
    //       type: "error",
    //     });
    //   }
    // },
  },
};
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
